<div class="modal-body">
    <cm-dynamic-form-content-details [contentDetails]="modalDetails"></cm-dynamic-form-content-details>
    <ng-container *ngFor="let element of elementsArray; let i = index">
        <cm-dynamic-form
            *ngIf="activeSequenceIndex === i"
            [isZeroValueAllowed]="true"
            [elements]="element"
            [showErrors]="showErrors"
            [sections]="sections"
            [disabled]="disabled"
            (updateFieldValue)="updateFieldValue($event)"
        ></cm-dynamic-form>
    </ng-container>
    <div class="form-errors" [ngClass]="{ 'show-errors': showErrors }">
        <p *ngFor="let errorText of dynamicFormErrors">{{ errorText }}</p>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="showUnsavedChangesModal()">CLOSE</button>
    <button type="button" *ngIf="!isFirstPage" class="btn btn-default" (click)="onBack()">BACK</button>
    <button type="button" class="btn btn-primary" (click)="onNext()" [disabled]="disabled">
        {{ activeSequenceIndex !== lastSequenceIndex ? 'NEXT' : 'CONTINUE' }}
    </button>
</div>
